import { gql, useMutation } from '@apollo/client';

import type { SetUserTimezoneMutation, SetUserTimezoneMutationVariables } from './__generated__/useSetUserTimezone.gql';

const SET_USER_TIMEZONE = gql`
  mutation SetUserTimezone($timezone: String!) {
    setUserTimezone(timezone: $timezone) {
      id
      timezone
      inferredTimezone
    }
  }
`;

export const useSetUserTimezone = () => {
  return useMutation<SetUserTimezoneMutation, SetUserTimezoneMutationVariables>(SET_USER_TIMEZONE);
};
